import { dataPaperPlaneSend } from 'dls-icons-data'
import { createIcon } from '../common'

const IconPaperPlaneSend = /*#__PURE__*/createIcon(dataPaperPlaneSend)
export default IconPaperPlaneSend
